import { logged_in as loggedIn, logged_account_number as accountNumber } from 'state';

window.dataLayer = window.dataLayer || [];

export const isTealiumEnabled = () => (
  typeof (window.utag) !== 'undefined'
);

export const copyTealiumData = ({
  virtual_page: virtualPage = `${window.location.pathname}${window.location.search}`,
  ...rest
} = {}) => ({
  ...window.utag.handler.C(window.utag_data),
  ...rest,
  virtual_page: virtualPage,
  ...(loggedIn() && {
    userAN: accountNumber(),
  }),
});

const callTealium = (type) => (data) => {
  try {
    if (isTealiumEnabled()) window.utag[type](copyTealiumData(data));
  } catch (e) {
    // Does nothing
  }
};

export const callTealiumView = callTealium('link');
export const callTealiumPageView = callTealium('view');
